import React, {useEffect, useState} from 'react'
import {Autocomplete, Box, Checkbox, FormControlLabel, Radio, RadioGroup, TextField} from '@mui/material'
import {State, City} from 'country-state-city'
import '../../reusable-components/styles/style.css'
import * as validator from '../Validation/Validations'
import {Country} from './ADDRESS_CONSTANTS'
import GoogleMaps from '../GoogleMaps/GoogleMaps'

const AddressForm = ({formData, setFormData, mailingInfo, addressInfo, disabled = false}) => {
  const [showMailingAddr, setShowMailingAddr] = useState<boolean>(false)
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [selectedState, setSelectedState] = useState(null)
  const [selectedMailingState, setSelectedMailingState] = useState(null)
  const [selectedMailingCountry, setSelectedMailingCountry] = useState(null)
  const [states, setStates] = useState([])
  const [city, setCity] = useState([])
  const [mailingCity, setMailingCity] = useState([])
  const [mailingStates, setMailingStates] = useState([])
  const [manualToggle, setManualToggle] = useState(false);
  useEffect(() => {
    const setAddressData = () => {
      setSelectedCountry({ label: formData?.addrInfo?.country, value: formData?.addrInfo?.country });
      setSelectedMailingCountry({ label: formData?.mailingInfo?.country, value: formData?.mailingInfo?.country });
      setSelectedState({ label: formData?.addrInfo?.state, value: formData?.addrInfo?.state });
      setSelectedMailingState({ label: formData?.mailingInfo?.state, value: formData?.mailingInfo?.state });
    };
  
    const areAddressesEqual = () => {
      const addressFields = [
        'st1', 'st2', 'city', 'country', 'zipCode', 'state',
        'primaryPhone', 'secondaryPhone', 'additionalPhone', 'accuracy'
      ];
      const isEqual = addressFields.every(field => {
        const addrValue = formData?.addrInfo?.[field];
        const mailValue = formData?.mailingInfo?.[field];
        return addrValue === mailValue || (!addrValue && !mailValue);
      });
      return isEqual;
    };
  
    setAddressData();
    if (!manualToggle) {
    setShowMailingAddr(!areAddressesEqual());
  }
  }, [formData?.addrInfo, formData?.mailingInfo]);
  

    useEffect(() => {
      const fetchData = async () => {
        try {
          const countryCodes = {
            "US": "US"
          };
          const country = countryCodes[selectedCountry?.label] || '';
          
          const stateOptions = country ? State.getStatesOfCountry(country).map((state) => ({
            label: state.name,
            value: state.isoCode,
          })) : [];
    
          const state = stateOptions.find((option) => option.label === selectedState?.label);
          const cityOptions = selectedState && state
            ? City.getCitiesOfState(country, state.value).map((city) => ({
                label: city.name,
                value: city.name,
              }))
            : [];
    
          setStates(stateOptions);
          setCity(cityOptions);
        } catch (err) {
          console.log(err);
        }
      };
      fetchData();
    }, [selectedCountry, selectedState]);
    
    useEffect(() => {
      const fetchData = async () => {
        try {
          const countryCodes = {
            "United States": "US"
          };
          const country = countryCodes[selectedMailingCountry?.label] || '';
    
          const mailingStateOptions = country ? State.getStatesOfCountry(country).map((state) => ({
            label: state.name,
            value: state.isoCode,
          })) : [];
    
          const state = mailingStateOptions.find((option) => option.label === selectedMailingState?.label);
          const mailingCityOptions = selectedMailingState && state
            ? City.getCitiesOfState(country, state.value).map((city) => ({
                label: city.name,
                value: city.name,
              }))
            : [];
    
          setMailingStates(mailingStateOptions);
          setMailingCity(mailingCityOptions);
        } catch (err) {
          console.log(err);
        }
      };
      fetchData();
    }, [selectedMailingCountry, selectedMailingState]);

    const [center, setCenter] = useState({
      lat: 0,
      lng: 0,
    })
    const [markerPosition, setMarkerPosition] = useState({
      lat: 0,
      lng: 0,
    })
    const [isMapInitialized, setIsMapInitialized] = useState(false);
  
    const [mailMarkerPosition, setMailMarkerPosition] = useState({
      lat: 0,
      lng: 0,
    })
  
    const [mailCenter, setMailCenter] = useState({
      lat: 0,
      lng: 0,
    })
  
    const [isMailMapInitialized, setIsMailMapInitialized] = useState(false);
    const [showMailMaps, setShowMailMaps] = useState(false)
    const [showMaps, setShowMaps] = useState(false)

  
  const updateLocationCoordinates = async (addressType = 'addrInfo') => {
  const addressData = formData?.[addressType];
  
  if (!addressData?.st1 || !addressData?.city || !addressData?.state || !addressData?.zipCode || !addressData?.country) {
    return;
  }

  const { st1, st2, city, state, zipCode, country } = addressData;
  const addressToCheck = `${st1} ${st2 || ''}, ${city}, ${state}, ${zipCode}, ${country}`;
  
  try {
    const geocoder = new window.google.maps.Geocoder();
    const geocode = await geocoder.geocode({ address: addressToCheck });
    
    if (geocode.results.length > 0) {
      const newPosition = {
        lat: geocode.results[0].geometry.location.lat(),
        lng: geocode.results[0].geometry.location.lng()
      };
      setFormData((prevFormData) => ({
        ...prevFormData,
        [addressType]: {
          ...prevFormData[addressType],
          lat: newPosition.lat,
          lng: newPosition.lng,
        },
      }));

      if (addressType === 'addrInfo') {
        setMarkerPosition(newPosition);
        setCenter(newPosition);
        if (!isMapInitialized) setIsMapInitialized(true);
      } else if (addressType === 'mailingInfo') {
        setMailMarkerPosition(newPosition);
        setMailCenter(newPosition);
        if (!isMailMapInitialized) setIsMailMapInitialized(true);
      }
    }
  } catch (error) {
    console.error('Geocoding error:', error);
  }
};

const toggleMapDisplay = (show, addressType = 'addrInfo') => {
  if (addressType === 'addrInfo') {
    setShowMaps(show);
  } else {
    setShowMailMaps(show);
  }
};
const changeLocationOnGoogleMaps = async (showMap) => {
  await updateLocationCoordinates('addrInfo');
  
  if (showMap !== undefined) {
    toggleMapDisplay(showMap, 'addrInfo');
  }
};

const changeMailLocationOnGoogleMaps = async (showMailMap) => {
  await updateLocationCoordinates('mailingInfo');
  
  if (showMailMap !== undefined) {
    toggleMapDisplay(showMailMap, 'mailingInfo');
  }
};
  return (
    <Box>
      {addressInfo?.addressInfo === true && (
        <>
          <Box display='flex' flexDirection='row' className='fieldRow'>
            <Box className='fieldContainer'>
              <TextField
                disabled={disabled}
                required={true}
                type='text'
                name='st1'
                size='small'
                className='textField'
                value={formData?.addrInfo?.st1 || ''}
                onChange={(e) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    addrInfo: {
                      ...prevState.addrInfo,
                      st1: e.target.value,
                    },
                  }))
                  if (!showMailingAddr) {
                    setFormData((prevState) => {
                      return {
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          st1: e.target.value,
                        },
                      }
                    })
                  }
                  updateLocationCoordinates('addrInfo');
                }}
                variant='outlined'
                label='Street 1'
                autoComplete='off'
                error={Boolean(
                  formData?.addrInfo?.st1 &&
                    !validator.STREET_VALIDATION.pattern.test(formData?.addrInfo?.st1)
                )}
                helperText={
                  formData?.addrInfo?.st1 &&
                  !validator.STREET_VALIDATION.pattern.test(formData?.addrInfo?.st1)
                    ? validator.STREET_VALIDATION.message
                    : ''
                }
              />
            </Box>
            <Box className='fieldContainer'>
              <TextField
                disabled={disabled}
                type='text'
                name='st2'
                size='small'
                className='textField'
                value={formData?.addrInfo?.st2 || ''}
                onChange={(e) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    addrInfo: {
                      ...prevState.addrInfo,
                      st2: e.target.value,
                    },
                  }))
                  if (!showMailingAddr) {
                    setFormData((prevState) => {
                      return {
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          st2: e.target.value,
                        },
                      }
                    })
                  }
                  updateLocationCoordinates('addrInfo');
                }}
                variant='outlined'
                label='Street 2'
                autoComplete='off'
                error={Boolean(
                  formData?.addrInfo?.st2 &&
                    !validator.STREET_VALIDATION.pattern.test(formData?.addrInfo?.st2)
                )}
                helperText={
                  formData?.addrInfo?.st2 &&
                  !validator.STREET_VALIDATION.pattern.test(formData?.addrInfo?.st2)
                    ? validator.STREET_VALIDATION.message
                    : ''
                }
              />
            </Box>
          </Box>

          <Box display='flex' flexDirection='row' className='fieldRow'>
            <Box className='fieldContainer'>
              <Autocomplete
                disabled={disabled || !formData?.addrInfo?.st1}
                options={Country || []}
                size='small'
                className='textField'
                value={Country?.find(option => option.value === formData?.addrInfo?.country) || null}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                onChange={(_, newValue) => {
                  const SelectedValue = newValue ? newValue : ''
                  setSelectedCountry(SelectedValue)
                  setFormData((prevState) => ({
                    ...prevState,
                    addrInfo: {
                      ...prevState.addrInfo,
                      country: SelectedValue ? SelectedValue.value : '',
                    },
                  }))
                  if (!showMailingAddr) {
                    setFormData((prevState) => {
                      return {
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          country: SelectedValue ? SelectedValue.value : '',
                        },
                      }
                    })
                  }
                 updateLocationCoordinates('addrInfo');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant='outlined'
                    label='- Select Country -'
                    required={true}
                  />
                )}
              />
            </Box>
            <Box className='fieldContainer'>
              <Autocomplete
                disabled={disabled || !formData?.addrInfo?.country}
                options={states}
                value={states.find(option => option.label === formData?.addrInfo?.state) || null}
                size='small'
                isOptionEqualToValue={(option, value) => option.label === value?.label}
                onChange={(_, newValue) => {
                  const SelectedValue = newValue ? newValue : ''
                  setSelectedState(SelectedValue)
                  setFormData((prevState) => {
                    return {
                      ...prevState,
                      addrInfo: {
                        ...prevState.addrInfo,
                        state: SelectedValue ? SelectedValue.label : '',
                      },
                    }
                  })

                  if (!showMailingAddr) {
                    setFormData((prevState) => {
                      return {
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          state: SelectedValue ? SelectedValue.label : '',
                        },
                      }
                    })
                  }
                  updateLocationCoordinates('addrInfo');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant='outlined'
                    label='- Select State -'
                    required={true}
                  />
                )}
              />
            </Box>
          </Box>

          <Box display='flex' flexDirection='row' className='fieldRow'>
            <Box className='fieldContainer'>
              <Autocomplete
                disabled={disabled || !formData?.addrInfo?.state}
                options={city}
                value={city.find(option => option.label === formData?.addrInfo?.city) || null}
                size='small'
                isOptionEqualToValue={(option, value) => option.label === value?.label}
                onChange={(_, newValue) => {
                  const SelectedValue = newValue ? newValue : ''
                  setFormData((prevState) => {
                    return {
                      ...prevState,
                      addrInfo: {
                        ...prevState?.addrInfo,
                        city: SelectedValue ? SelectedValue.label : '',
                      },
                    }
                  })
                  if (!showMailingAddr) {
                    setFormData((prevState) => {
                      return {
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          city: SelectedValue ? SelectedValue.label : '',
                        },
                      }
                    })
                  }
                  updateLocationCoordinates('addrInfo');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant='outlined'
                    label='- Select City -'
                    required={true}
                  />
                )}
              />
            </Box>
            <Box className='fieldContainer'>
              <TextField
                required={true}
                disabled={disabled || !formData?.addrInfo?.city}
                type='text'
                name='zipCode'
                size='small'
                className='textField'
                fullWidth
                value={formData?.addrInfo?.zipCode || ''}
                onChange={(e) => {
                  const {value} = e.target
                  const formattedValue = value.replace(/[^0-9]/g, '').slice(0, 5)
                  setFormData((prevState) => {
                    return {
                      ...prevState,
                      addrInfo: {
                        ...prevState.addrInfo,
                        zipCode: formattedValue,
                      },
                    }
                  })
                  if (!showMailingAddr) {
                    setFormData((prevState) => {
                      return {
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          zipCode: formattedValue,
                        },
                      }
                    })
                  }
                  updateLocationCoordinates('addrInfo');
                }}
                variant='outlined'
                label='Zip Code'
                autoComplete='off'
                error={Boolean(
                  formData?.addrInfo?.zipCode &&
                    !validator.ZIP_CODE_VALIDATION.pattern.test(formData?.addrInfo?.zipCode)
                )}
                helperText={
                  formData?.addrInfo?.zipCode &&
                  !validator.ZIP_CODE_VALIDATION.pattern.test(formData?.addrInfo?.zipCode)
                    ? validator.ZIP_CODE_VALIDATION.message
                    : ''
                }
              />
            </Box>
          </Box>
          <Box display='flex' flexDirection='row' className='fieldRow'>
            <Box className='fieldContainer'>
              <TextField
                disabled={disabled}
                type='text'
                name='primaryPhone'
                size='small'
                className='textField'
                fullWidth
                value={formData?.addrInfo?.primaryPhone || ''}
                onChange={(e) => {
                  const {value} = e.target
                  const formattedValue = value.replace(/[^0-9]/g, '').slice(0, 10)
                  setFormData((prevState) => {
                    return {
                      ...prevState,
                      addrInfo: {
                        ...prevState.addrInfo,
                        primaryPhone: formattedValue,
                      },
                    }
                  })
                  if (!showMailingAddr) {
                    setFormData((prevState) => {
                      return {
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          primaryPhone: formattedValue,
                        },
                      }
                    })
                  }
                }}
                variant='outlined'
                label='Primary Phone'
                autoComplete='off'
                error={Boolean(
                  formData?.addrInfo?.primaryPhone &&
                    !validator.PHONE_NUMBER_VALIDATION.pattern.test(
                      formData?.addrInfo?.primaryPhone
                    )
                )}
                helperText={
                  formData?.addrInfo?.primaryPhone &&
                  !validator.PHONE_NUMBER_VALIDATION.pattern.test(formData?.addrInfo?.primaryPhone)
                    ? validator.PHONE_NUMBER_VALIDATION.message
                    : ''
                }
              />
            </Box>
            <Box className='fieldContainer'>
              <TextField
                  disabled={disabled}
                  required={true}
                  type="number"
                  name="accuracy"
                  size='small'
                  className='textField'
                  value={formData?.addrInfo?.accuracy}
                  onChange={(e) => {
                      setFormData((prevState) => {
                          return {
                              ...prevState,
                              addrInfo: {
                                  ...prevState.addrInfo,
                                  accuracy: e.target.value
                              }
                          }
                      })
                  }}
                  variant="outlined"
                  label="Accuracy (in yards)"
                  autoComplete="off"
              />
            </Box>
          </Box>

          <Box display='flex' flexDirection='row' className='fieldRow'>
              <div>
                <Box className="fieldContainer" style={{ display: 'flex', alignItems: 'center' }}>
                  <FormControlLabel
                    label="Show Location on Map"
                    control={
                    <Checkbox
                    disabled={!formData?.addrInfo?.zipCode || disabled}
                    checked={showMaps}
                     onChange={(e) => {
                      toggleMapDisplay(e.target.checked, 'addrInfo');
                      changeLocationOnGoogleMaps(e.target.checked); // Show location on map when checkbox is checked
                    }}
                    />
                    }
                    />
                    </Box>
                      {showMaps && (
                      <Box style={{ width: '70vw', height: '400px', marginTop: '16px' }}>
                        <GoogleMaps center={center} markerPosition={markerPosition} />
                      </Box>
                                    )}
                </div>
          </Box>
        </>
      )}

      {mailingInfo && (
        <Box display='flex' flexDirection='row' className='fieldRow'>
          <Box className='fieldContainer'>
            <label className='fw-bold fs-6'>Is Mailing Address the same as Residential ?</label>
           <RadioGroup 
        value={showMailingAddr ? 'no' : 'yes'} 
        onChange={(e) => {
            const value = e.target.value;
            setManualToggle(value === 'no');
            setShowMailingAddr(value === 'no');
            
            if (value === 'yes') {
                setFormData((prevData) => ({
                    ...prevData,
                    mailingInfo: {
                        ...prevData.addrInfo,
                    }
                }));
            } else {
                setFormData((prevData) => ({
                    ...prevData,
                    mailingInfo: {
                        st1: '',
                        st2: '',
                        primaryPhone: '',
                        secondaryPhone: '',
                        additionalPhone: '',
                        zipCode: '',
                        state: '',
                        city: '',
                        country: '',
                        accuracy: 90,
                    }
                }));
            }
        }} 
        row
    >
        <FormControlLabel
            value='yes'
            control={<Radio />}
            label='Yes'
            labelPlacement='end'
        />
        <FormControlLabel
            value='no'
            control={<Radio />}
            label='No'
            labelPlacement='end'
        />
           </RadioGroup>
              </Box>
            </Box>
          )}

      {showMailingAddr ? (
        <>
          {mailingInfo?.mailingInfo === true && (
            <>
              <Box display='flex' flexDirection='row' className='fieldRow'>
                <Box className='fieldContainer'>
                  <TextField
                    required={true}
                    type='text'
                    name='st1'
                    size='small'
                    className='textField'
                    value={formData?.mailingInfo?.st1 || ''}
                    onChange={(e) => {
                      setFormData((prevState) => ({
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          st1: e.target.value,
                        },
                      }))
                      updateLocationCoordinates('mailingInfo');
                    }}
                    variant='outlined'
                    label='Street 1'
                    autoComplete='off'
                    error={Boolean(
                      formData?.mailingInfo?.st1 &&
                        !validator.STREET_VALIDATION.pattern.test(formData?.mailingInfo?.st1)
                    )}
                    helperText={
                      formData?.mailingInfo?.st1 &&
                      !validator.STREET_VALIDATION.pattern.test(formData?.mailingInfo?.st1)
                        ? validator.STREET_VALIDATION.message
                        : ''
                    }
                  />
                </Box>
                <Box className='fieldContainer'>
                  <TextField
                    type='text'
                    name='st2'
                    size='small'
                    className='textField'
                    value={formData?.mailingInfo?.st2 || ''}
                    onChange={(e) => {
                      setFormData((prevState) => ({
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          st2: e.target.value,
                        },
                      }))
                      updateLocationCoordinates('mailingInfo');
                    }}
                    variant='outlined'
                    label='Street 2'
                    autoComplete='off'
                    error={Boolean(
                      formData?.mailingInfo?.st2 &&
                        !validator.STREET_VALIDATION.pattern.test(formData?.mailingInfo?.st2)
                    )}
                    helperText={
                      formData?.mailingInfo?.st2 &&
                      !validator.STREET_VALIDATION.pattern.test(formData?.mailingInfo?.st2)
                        ? validator.STREET_VALIDATION.message
                        : ''
                    }
                  />
                </Box>
              </Box>
              <Box display='flex' flexDirection='row' className='fieldRow'>
                <Box className='fieldContainer'>
                  <Autocomplete
                    disabled={disabled || !formData?.mailingInfo?.st1}
                    options={Country}
                    size='small'
                    className='textField'
                    value={formData?.mailingInfo?.country || ''}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    onChange={(_, newValue) => {
                      const SelectedValue = newValue ? newValue : ''
                      setSelectedMailingCountry(SelectedValue ? SelectedValue?.value : '')
                      setFormData((prevState) => ({
                        ...prevState,
                        mailingInfo: {
                          ...prevState.mailingInfo,
                          country: SelectedValue ? SelectedValue?.label : '',
                        },
                      }))
                      updateLocationCoordinates('mailingInfo');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant='outlined'
                        label='- Select Country -'
                        required={true}
                      />
                    )}
                  />
                </Box>
                <Box className='fieldContainer'>
                  <Autocomplete
                    disabled={disabled || !formData?.mailingInfo?.country}
                    options={mailingStates}
                    value={mailingStates.find(option => option.label === formData?.mailingInfo?.state) || null}
                    size='small'
                    isOptionEqualToValue={(option, value) => option.label === value?.label}
                    onChange={(_, newValue) => {
                      const SelectedValue = newValue ? newValue : ''
                      setSelectedMailingState(SelectedValue)
                      setFormData((prevState) => {
                        return {
                          ...prevState,
                          mailingInfo: {
                            ...prevState?.mailingInfo,
                            state: SelectedValue ? SelectedValue.label : '',
                          },
                        }
                      })
                      updateLocationCoordinates('mailingInfo');
                    }}
                    renderInput={(params) => (
                      <TextField {...params} variant='outlined' label='- Select State -' />
                    )}
                  />
                </Box>
              </Box>
              <Box display='flex' flexDirection='row' className='fieldRow'>
                <Box className='fieldContainer'>
                  <Autocomplete
                    disabled={disabled || !formData?.mailingInfo?.state}
                    options={mailingCity}
                    value={mailingCity.find(option => option.label === formData?.mailingInfo?.city) || null}
                    size='small'
                    isOptionEqualToValue={(option, value) => option.label === value?.label}
                    onChange={(_, newValue) => {
                      const SelectedValue = newValue ? newValue : ''
                      setFormData((prevState) => {
                        return {
                          ...prevState,
                          mailingInfo: {
                            ...prevState?.mailingInfo,
                            city: SelectedValue ? SelectedValue.label : '',
                          },
                        }
                      })
                      updateLocationCoordinates('mailingInfo');
                    }}
                    renderInput={(params) => (
                      <TextField {...params} variant='outlined' label='- Select City -' />
                    )}
                  />
                </Box>
                <Box className='fieldContainer'>
                  <Box className='fieldContainer'>
                    <TextField
                      required={true}
                      disabled={disabled ||   !formData?.mailingInfo?.city}
                      type='text'
                      name='zipCode'
                      size='small'
                      className='textField'
                      fullWidth
                      value={formData?.mailingInfo?.zipCode || ''}
                      onChange={(e) => {
                        const {value} = e.target
                        const formattedValue = value.replace(/[^0-9]/g, '').slice(0, 5)
                        setFormData((prevState) => {
                          return {
                            ...prevState,
                            mailingInfo: {
                              ...prevState.mailingInfo,
                              zipCode: formattedValue,
                            },
                          }
                        })
                        updateLocationCoordinates('mailingInfo');
                      }}
                      variant='outlined'
                      label='Zip Code'
                      autoComplete='off'
                      error={Boolean(
                        formData?.mailingInfo?.zipCode &&
                          !validator.ZIP_CODE_VALIDATION.pattern.test(
                            formData?.mailingInfo?.zipCode
                          )
                      )}
                      helperText={
                        formData?.mailingInfo?.zipCode &&
                        !validator.ZIP_CODE_VALIDATION.pattern.test(formData?.mailingInfo?.zipCode)
                          ? validator.ZIP_CODE_VALIDATION.message
                          : ''
                      }
                    />
                  </Box>
                </Box>
              </Box>
              <Box display='flex' flexDirection='row' className='fieldRow'>
                <Box className='fieldContainer'>
                  <TextField
                    disabled={disabled}
                    type='text'
                    name='primaryPhone'
                    size='small'
                    className='textField'
                    fullWidth
                    value={formData?.mailingInfo?.primaryPhone || ''}
                    onChange={(e) => {
                      const {value} = e.target
                      const formattedValue = value.replace(/[^0-9]/g, '').slice(0, 10)
                      setFormData((prevState) => {
                        return {
                          ...prevState,
                          mailingInfo: {
                            ...prevState.mailingInfo,
                            primaryPhone: formattedValue,
                          },
                        }
                      })
                    }}
                    variant='outlined'
                    label='Primary Phone'
                    autoComplete='off'
                    error={Boolean(
                      formData?.mailingInfo?.primaryPhone &&
                        !validator.PHONE_NUMBER_VALIDATION.pattern.test(
                          formData.mailingInfo.primaryPhone
                        )
                    )}
                    helperText={
                      formData?.mailingInfo?.primaryPhone &&
                      !validator.PHONE_NUMBER_VALIDATION.pattern.test(formData?.mailingInfo?.primaryPhone)
                        ? validator.PHONE_NUMBER_VALIDATION.message
                        : ''
                    }
                  />
                </Box>
                <Box className='fieldContainer'>
                  <TextField
                      disabled={disabled}
                      required={true}
                      type="number"
                      name="accuracy"
                      size='small'
                      className='textField'
                      value={formData?.mailingInfo?.accuracy }
                      onChange={(e) => {
                          setFormData((prevState) => {
                              return {
                                  ...prevState,
                                  mailingInfo: {
                                      ...prevState.mailingInfo,
                                      accuracy: e.target.value
                                  }
                              }
                          })
                      }}
                      variant="outlined"
                      label="Accuracy (in yards)"
                      autoComplete="off"
                  />
                </Box>
              </Box>
              <div>
              <Box className="fieldContainer" style={{ display: 'flex', alignItems: 'center', marginLeft:"10px" }}>
                <FormControlLabel
                  label="Show Location on Map"
                  control={
                  <Checkbox
                    disabled={disabled || !formData?.mailingInfo?.zipCode}
                    checked={showMailMaps}
                   onChange={(e) => {
                      toggleMapDisplay(e.target.checked, 'mailingInfo');
                      changeMailLocationOnGoogleMaps(e.target.checked); 
                    }}
                    />
                    }
                  />
              </Box>
                {showMailMaps && (
                  <Box style={{ width: '70vw', height: '400px', marginTop: '16px' }}>
                  <GoogleMaps center={mailCenter} markerPosition={mailMarkerPosition} />
                  </Box>
                  )}
              </div>
            </>
          )}
        </>
      ) : null}
    </Box>
  )
}

export default AddressForm
